 <!-- 报警触发 -->
<template>
  <div class="page_content">
    <div class="tab">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="综合触发器" name="first">
          <zhTrigger></zhTrigger>
        </el-tab-pane>
        <el-tab-pane label="设备触发器" name="second">
          <deviceTrigger></deviceTrigger>
        </el-tab-pane>
      </el-tabs>
    </div>
    </div>
</template>
<script>
import zhTrigger  from '@/components/alarmTrigger/zhTrigger.vue'
import deviceTrigger from '@/components/alarmTrigger/deviceTrigger.vue'
export default {
  name:'alarmTrigger',
  components: {
    zhTrigger,
    deviceTrigger
  },
  data() {
    return {
      activeName: 'first', //tab切换

    };
  },
  methods: {
    // 菜单触发
    handleClick() {},
  }
};
</script>
<style scoped lang="less">
    /* tab */
    ::v-deep .el-tabs__item {
      color: #405891;
      font-size: 0.16rem;
    }
    ::v-deep .el-tabs__item:hover {
      color:#405891
    }
    ::v-deep .el-tabs__item.is-active {
      color: #405891;
      font-weight: 600;
    }
    ::v-deep .el-tabs__active-bar {
      background-color: #405891;
    }
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-tabs__nav-wrap {
      background: #fff;
      padding: 0.2rem 0 0 0.24rem;
    }
    ::v-deep .el-tabs__header {
      margin: 0;
    }
</style>